import React, { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import { getThemeFromCookie, setThemeCookie } from '../utils/theme';

export const ThemeContext = createContext({ theme: 'light', setTheme: () => {} });

function applyTheme(value) {
	document.documentElement.setAttribute('data-theme', value);
	const meta = document.querySelector('meta[name="theme-color"]');
	if (meta) meta.setAttribute('content', value === 'dark' ? '#1a1d22' : '#ffffff');
}

export function ThemeProvider({ children }) {
	const [theme, setThemeState] = useState('light');

	useEffect(() => {
		const initial = getThemeFromCookie();
		setThemeState(initial);
		applyTheme(initial);
	}, []);

	const setTheme = useCallback((next) => {
		const value = next === 'dark' ? 'dark' : 'light';
		setThemeState(value);
		setThemeCookie(value);
		applyTheme(value);
	}, []);

	const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);

	return (
		<ThemeContext.Provider value={value}>
			{children}
		</ThemeContext.Provider>
	);
}
